import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {scheduleCardSchema} from '../../schemas/scheduleCardSchema';
import addOrUpdateCardTool from '../general/addOrUpdateCardTool/addOrUpdateCardTool';
import getFilesTool from 'common/src/modules/shared/copilot/tools/getFilesTool';
import readValuesFromExcelTool from '../general/readValuesFromExcelTool/readValuesFromExcelTool';

export default function addOrUpdateScheduleCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.SCHEDULE,
    cardSchema: scheduleCardSchema,
    tools: [getFilesTool(), readValuesFromExcelTool()],
    cardSpecificInstructions:
      'Fallback output is selected when no other outputs match. Capable of reading values from an excel file',
  });
}
